import {
  SprievodnyDokumentExistsApi,
  SprievodnyDokumentStatus,
} from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import Uuid from '../../../model/Uuid';
import { ClientResponse } from '../../../model/ClientResponse';

const client = new SprievodnyDokumentExistsApi(apiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchSprievodnyDokumentExists = async (
  legMaterialUuid: Uuid,
  sprievodnyDokumentKod: string,
  stadiumHistoriaUuid?: string,
  headers?: object,
):
  Promise<ClientResponse<SprievodnyDokumentStatus>> => {
  const {
    data,
    status,
  } = await client.existSprievodnyDokument(legMaterialUuid, sprievodnyDokumentKod, stadiumHistoriaUuid, headers);
  return {
    data,
    responseCode: status,
  };
};
